export const environment = {
    production: false,

    apiUrl: 'http://localhost:8000/api/v1',

    keycloak: {
        url: 'http://localhost:8080',
        realm: 'product_bridge',
        clientId: 'product_bridge'
    }
};